// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  bundleContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  selectedBundle: {
    border: `2px solid ${theme.palette.primary.main}`,
    opacity: 1,
    background: '#fff',
    boxShadow: '0 2px 12px 0 rgba(0,0,0,0.10)',
  },
  bundleOption: {
    width: '100%',
    padding: '5px',
    '& .MuiTypography-body1': {
      width: '100%',
    },
  },
});

export default styles;
